export default __webpack_public_path__ + "static/media/001.d93c6424.jpg";